<div class="banner" [ngClass]="{'hidden': !showBannerApp}">
	<h4 class="title">Descarga nuestra app</h4>
	<Button class="btn" (click)="downloadApp()">Descargar</Button>
</div>